import { useTranslation } from 'react-i18next'
import { dataTestIds } from '@velasca/constants'
import { CartIcon } from '@velasca/icons/cart'
import { Button } from '../Button/Button'
import type { ShopTheLookButtonProps } from './ShopTheLookButton.types'

export const ShopTheLookButton = ({
  className = '',
  onClick,
}: ShopTheLookButtonProps): JSX.Element => {
  const { t } = useTranslation('product')

  return (
    <Button
      variant="frosted"
      className={className}
      Icon={CartIcon}
      text={t('shopTheLook')}
      dataTestId={dataTestIds.SHOP_THE_LOOK_BUTTON}
      onClick={onClick}
    />
  )
}
